import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { PasswordInput } from '@/components/PasswordInput';
import { ProgressBar } from '@/components/ProgressBar';
import { validatePasswordStrength } from '@/services/validationService';
import { colors } from '@/styles/colors';

interface PasswordInputWithStrengthProps {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder: string;
  showStrength?: boolean;
  error?: string;
  testID?: string;
  onSubmitEditing?: () => void;
}

export const PasswordInputWithStrength: React.FC<PasswordInputWithStrengthProps> = ({
  label,
  value,
  onChangeText,
  placeholder,
  showStrength = false,
  error,
  testID,
  onSubmitEditing,
}) => {
  const validation = validatePasswordStrength(value);
  
  // Show message when field has content
  const showMessage = showStrength && value.length > 0;
  const message = validation.error || 'Now confirm your new password';
  const hasError = !!validation.error;

  return (
    <View style={styles.container}>
      <PasswordInput
        label={label}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        error={error}
        testID={testID}
        onSubmitEditing={onSubmitEditing}
      />
      
      {showMessage && (
        <>
          <ProgressBar 
            strength={validation.strength} 
            hasError={hasError}
          />
          <Text style={[
            styles.message,
            hasError ? styles.errorMessage : styles.successMessage
          ]}>
            {message}
          </Text>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  message: {
    fontSize: 14,
    marginTop: 8,
    minHeight: 20,
  },
  errorMessage: {
    color: colors.warning,
  },
  successMessage: {
    color: colors.success,
  },
});
